export default "__VITE_ASSET__ee033b93__"